<template>
    <ui-sidebar-float
        :overlay-close="true"
        load-text="Carregando..."
        name="profile-points-feed"
        title="Extrato de Pontos"
    >
        <ui-feed>
            <template #header>
                <div class="filters">
                    <div class="title">
                        <strong>{{ totalComputed }}</strong> próximos de vencer
                    </div>
                    <div>
                        <ui-select v-model="filter" label="Filtrar: " size="md" :clearable="false">
                            <option value="debit">Débito</option>
                            <option value="credit">Crédito</option>
                            <option value="all" selected>Todos</option>
                        </ui-select>
                    </div>
                </div>
            </template>
            <div v-if="filteredPoints.length > 0" >
                <ui-points-feed-card v-for="item in filteredPoints" :key="item.balance_id" :data="item" />
            </div>
            <div v-else class="no-points">
                <ui-page-message
                    icon="fal fa-file-contract"
                    text="Não existem pontos transitados para esta conta"
                />
            </div>
        </ui-feed>
    </ui-sidebar-float>
</template>

<script>
	import { uiSidebarFloat, uiFeed, uiPageMessage 	} from '@/components/ui'
	import { uiSelect 								} from '@/components/ui/form'
	import { user 									} from '@/services/axios'
	import { storage 								} from '@/services/storage'
	import uiPointsFeedCard 						  from '../points-feed-card'


	export default {
		name: 'ui-points-feed-sidebar',
		components: {
			uiSidebarFloat,
			uiFeed,
			uiSelect,
			uiPointsFeedCard,
			uiPageMessage
		},

		props: {
			data: {
				type: Object,
				required: true,
				default: function () {
					return {}
				},
			},
		},

		data() {
			return {
				getStorage: null,
				filter: 'all',
				points: {
					data: [],
					total: null,
					expiring: null,
				},
			}
		},

		computed: {
			/**
			 * Busca os dados do user no local storage
			 * Seta os dados no state
			 */
			storageComputed: {
				get() {
					return JSON.parse(storage.get('user_logged'))
				},
			},

			/**
			 * Valida se a data de expirar os pontos está próximo
			 */
			totalComputed() {
				let quantity = Number(this.points.total) <= 1 ? '' : 's'
				return `${this.points.total} ponto${quantity}`
			},

			/**
			 * Filra os pontos do usuário
			 */
			filteredPoints() {
				if (this.filter == '' || this.filter === 'all') return this.points.data
				return this.points.data.filter((item) => item.type.toLowerCase() === this.filter)
			},
		},

		beforeCreate() {
			this.$nextTick(() => {
				/**
				 * Busca os pontos do Usuário
				 */
				user.getPoints(this.storageComputed.id).then((response) => {
					this.$set(this.points, 'total', response.data.value)
					this.$set(this.points, 'expiring', response.data.expiring)
				})

				/**
				 * Busca o total de pontos do usuário
				 */
				user.getAllPoints(this.storageComputed.id).then((response) => {
					this.$set(this.points, 'data', response.data)
				})
			})
		},

		methods: {},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
